import React from 'react';
import AddSession from './AddSession';

const AddSessionForm = () => {

    return (
        <AddSession />
    );
};

export default AddSessionForm;